angular.module('bb.listing_search', ['ngRoute']);

require('./listing_search.service');
require('./appointment_search.service');

require('./user_listing.component');
require('./listing_search.component');
require('./listing_search_table.component');
require('./appointment_search.component');
require('./appointment_search_table.component');
require('./appointment_filter_modal.component');

require('./listing_search.routes');
